const form = {
  validation: {
    salutation: {
      empty: 'Bitte wählen Sie eine Anrede',
    },
    firstName: {
      empty: 'Vorname darf nicht leer sein',
      format: {
        lettersOnly: 'Zahlen und Sonderzeichen sind nicht möglich',
      },
    },
    lastName: {
      empty: 'Nachname darf nicht leer sein',
      format: {
        lettersOnly: 'Zahlen und Sonderzeichen sind nicht möglich',
      },
    },
    phoneCountryCode: {
      empty: 'Bitte wählen Sie eine Ländervorwahl',
    },
    phone: {
      empty: 'Telefonnummer darf nicht leer sein.',
      min: 'Die Telefonnummer ist zu kurz.',
      min2: 'Die Telefonnummer ist zu kurz. Bitte kontrollieren Sie Ihre Eingabe.',
      max: 'Die maximale Zeichenanzahl wurde überschritten. Bitte geben Sie eine Rufnummer mit max. 20 Zeichen ein.',
      format: {
        numbersOnly: 'Es sind nur Zahlen erlaubt.',
      },
    },
    mobileCountryCode: {
      empty: 'Bitte wählen Sie eine Ländervorwahl',
    },
    mobile: {
      empty: 'Mobilnummer darf nicht leer sein.',
      min: 'Die Mobilnummer ist zu kurz.',
      min2: 'Die Mobilnummer ist zu kurz. Bitte kontrollieren Sie Ihre Eingabe.',
      max: 'Die maximale Zeichenanzahl wurde überschritten. Bitte geben Sie eine Rufnummer mit max. 20 Zeichen ein.',
      format: {
        numbersOnly: 'Es sind nur Zahlen erlaubt.',
      },
    },
    email: {
      empty: 'E-Mail-Adresse darf nicht leer sein.',
      format: 'Dies ist keine gültige E-Mail-Adresse. Bitte prüfen Sie Ihre Eingabe.',
    },
    message: {
      empty: 'Ihre Nachricht darf nicht leer sein.',
    },
    password: {
      min: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
      empty: 'Passwort darf nicht leer sein.',
      error: 'Das Passwort muss alle Voraussetzungen erfüllen.',
    },
    policy: {
      bothNotAccepted: 'Bitte akzeptieren Sie unsere Nutzungsbedingungen und Datenschutzhinweise',
      termsOfUseNotAccepted: 'Bitte akzeptieren Sie unsere Nutzungsbedingungen',
      privacyPolicyNotAccepted: 'Bitte akzeptieren Sie unsere Datenschutzhinweise',
      consentNotAccepted: 'Bitte akzeptieren Sie die Weiterleitung Ihrer Bestelldaten an die Apotheke.',
    },
    street: {
      empty: 'Straße darf nicht leer sein',
    },
    houseNumber: {
      empty: 'Hausnummer darf nicht leer sein',
      format: {
        numberRequired: 'Bitte tragen Sie eine Zahl ein',
        invalidOrder: 'Bitte geben Sie zuerst die Hausnummer und dann den Buchstaben ein. Die Hausnummer muss aus mindestens einer Zahl bestehen.',
        specialCharacters: 'Dieses Sonderzeichen ist ungültig',
      },
    },
    zipCode: {
      empty: 'PLZ darf nicht leer sein',
      format: {
        numbersOnly: 'Es sind nur Zahlen erlaubt.',
        length: 'PLZ darf aus 5 Zahlen bestehen',
      },
    },
    city: {
      tooShort: 'Der Ortsname muss mind. 2 Buchstaben enthalten',
      tooLong: 'Der Ortsname ist zu lang',
      symbolNotAllowed: 'Dieses Sonderzeichen ist nicht erlaubt',
      atLeastTwoLetters: 'Geben Sie mindestens 2 Buchstaben ein',
    },
  },
  password: {
    tags: {
      min8char: '8 Zeichen',
      capChar: 'Großbuchstabe',
      lowChar: 'Kleinbuchstabe',
      numberChar: 'Zahl',
      specChar: 'Sonderzeichen',
    },
  },
}

export default form
